exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.i(require("-!../../../node_modules/css-loader/dist/cjs.js??ref--9-1!../../../node_modules/postcss-loader/src/index.js!../../styleGuide.css"), "");
// Module
exports.push([module.id, ".src-components-ImplicationsSmall-ImplicationsSmall__implications--Gpl1A{display:-webkit-box;display:flex;background:#fff;padding-right:5rem}", ""]);
// Exports
exports.locals = {
	"primaryColorDark": "" + require("-!../../../node_modules/css-loader/dist/cjs.js??ref--9-1!../../../node_modules/postcss-loader/src/index.js!../../styleGuide.css").locals["primaryColorDark"] + "",
	"implications": "src-components-ImplicationsSmall-ImplicationsSmall__implications--Gpl1A"
};